<template>
  <div class="order-details">
    <!--顶部导航-->
    <Navbar
      title="订单详情"
      :leftArrow="false"
      :isNotify="false"
      :isCustomerService="false"
      :isSpecialBack="true"
      @goBack="handleBack"
    >
      <template #right>
        <div class="right-content" @click="qimoChatClick">
          <img
            class="customerServiceIcon"
            src="@/assets/style/order/customerServic.png"
            alt=""
          />
        </div>
      </template>
    </Navbar>
    <!--内容区域-->
    <div class="content">
      <div class="content-wrap">
        <!--订单详情卡片-->
        <order-details-card />
        <!--订单详情账户-->
        <order-details-account />
      </div>
      <!--订单详情还款计划-->
      <order-details-payment-plan
        :stepList="stepList"
        :currentStep="currentStep"
      />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import orderDetailsCard from "@/components/orderDetails/orderDetailsCard.vue";
import orderDetailsAccount from "@/components/orderDetails/orderDetailsAccount.vue";
import orderDetailsPaymentPlan from "@/components/orderDetails/orderDetailsPaymentPlan.vue";
import { getOnroadBorrowOrderDetail } from "@/api/index.js";

export default {
  name: "orderDetails",
  components: {
    Navbar,
    orderDetailsCard,
    orderDetailsAccount,
    orderDetailsPaymentPlan,
  },
  data() {
    return {
      stepList: [],
      currentStep: 1,
      routerFlag: "1",
      isNavigatingAway: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name != "agreement") {
        vm.routerFlag = "2";
        vm.isNavigatingAway = false;
      } else {
        vm.routerFlag = "1";
      }
    });
  },
  async activated() {
     document.documentElement?.style?.setProperty?.('--status-bar-bg', '#F24334');
    if (this.routerFlag == "2") {
      const borrowOrderId = this.$route.query.borrowOrderId;
      const res = await getOnroadBorrowOrderDetail(borrowOrderId);
      if (res.code === 2000) {
        this.$store.commit("setOrderDetails", res.data);
        sessionStorage.setItem(
          "orderAgreement",
          JSON.stringify(res.data.agreement),
        );
        this.stepList = [
          {
            title: "提交申请",
            desc: res.data.createTime ? res.data.createTime : "进行中",
          },
          {
            title: "资质审查",
            desc: res.data.reviewRiskTime
              ? res.data.reviewRiskTime
              : res.data.createTime
              ? "进行中"
              : "",
          },
          {
            title: "银行代发",
            desc: res.data.lendingTime
              ? res.data.lendingTime
              : res.data.reviewRiskTime
              ? "进行中"
              : "",
          },
        ];
        this.currentStep = res.data.createTime
          ? res.data.reviewRiskTime
            ? res.data.lendingTime
              ? 4
              : 3
            : 2
          : 1;
      } else {
        this.$toast(res.msg || res.message || "获取订单详情失败");
      }
      return;
    }
  },
  methods: {
    qimoChatClick() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
         const clientId = localStorage.getItem("phone") ? `phone_${localStorage.getItem("phone")}` : "";
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=7db6e8d0-6ed3-11f1-acd0-59b3051d5398&clientId=${clientId}&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN`,
        );
      }
    },
    handleBack() {
      if (this.$store.getters.routerFlag == "2") {
        this.$store.commit("setRouterFlag", "1");
        localStorage.setItem("actived", 1);
        this.$router.push({
          name: "Home",
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.order-details {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #f5f6f7;
  background-image: url("@/assets/style/load/load-bg.png");
  background-size: 100% 35%;
  background-repeat: no-repeat;
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
::v-deep(.van-nav-bar__title) {
  color: #fff;
}
.content {
  padding: 0px 16px;
  .content-wrap {
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
  }
}
.customerServiceIcon {
  width: 24px;
  height: 24px;
  padding-left: 16px;
}
</style>
